import cn from "../../../utils/cn";
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const Divider = props => {
  const {
    id,
    className,
    style
  } = props;
  const uiDividerClass = 'border-0 border-b-2 border-dark-fill-blue';
  const dividerClass = cn(uiDividerClass, className);
  return /*#__PURE__*/_jsx("hr", {
    id: id,
    className: dividerClass,
    style: style,
    "data-testid": id
  });
};
Divider.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};
export default Divider;
//# sourceMappingURL=Divider.js.map